import React from 'react'
import { FaPlus, FaTimes } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type AddToShapeControlProps = {
  active: boolean
  onStart: () => void
  onCancel: () => void
}

// Toggles between "start adding" (plus) and "cancel adding" (x) for the same button.
const AddToShapeControl = ({ active, onStart, onCancel }: AddToShapeControlProps) => {
  const label = active ? 'Cancel adding to shape' : 'Add to shape'

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (active) onCancel()
    else onStart()
  }

  return (
    <div className={cn('control', 'add-to-shape')} data-graph-type="control" title={label}>
      <a className={cn('icon', { active })} onClick={handleClick}>
        {active ? <FaTimes aria-hidden /> : <FaPlus aria-hidden />}
        <span className="sr-only">{label}</span>
      </a>
    </div>
  )
}

export default AddToShapeControl
